/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const paymentMethodDataSchema = z.object({
	id: z.string(),
	stripePaymentMethodId: z.string(),
	stripeCustomerId: z.string().nullable(),
	type: z.string(),
	isDefault: z.boolean(),
	nickname: z.string().nullable(),
	details: z.union([
		z.object({ brand: z.string(), last4: z.string(), expMonth: z.number(), expYear: z.number() }),
		z.object({ last4: z.string(), country: z.string() }),
	]),
})

export type PaymentMethodDataSchema = z.infer<typeof paymentMethodDataSchema>
